import type {OrderProductState} from 'modules/Orders/types';

export const ORDER_PRODUCT_STATE_LABELS: Partial<Record<OrderProductState, string>> = {
  deleted: 'حذف شده',
  new: 'اضافه شده',
  edited: 'تغییر در تعداد'
};
